import { NOT_FOUND_TYPES, ResponseError } from "../defaults";

export const isResourceNotFoundError = (error: unknown) =>
    error instanceof ResponseError && error.status === 404 && NOT_FOUND_TYPES.has(error.problem?.type ?? "");
